var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { first } from '../first';
import { typeOf } from '../../type/typeOf';
import { isNilOrEmpty } from '../../value/isNilOrEmpty';
/**
 * Immutably removes an item at the specified index of the array
 *
 * @category Array
 * @template {T} - The type of the array
 * @param {T[]} array - The array of items
 * @param {...number} indexes - The index(es) of the item(s) to remove; use a negative index to count from the end
 * @returns {T[]}
 * @example
 * const array = [7, 5, 21];
 *
 * removeAt(array, 1)  //=> [7, 21]
 * removeAt(array, -1)  //=> [7, 5]
 *
 * // remove multiple items
 * removeAt(array, 1, 2)  //=> [7]
 * removeAt(array, -1, 0)  //=> [5]
 * @docgen_example
 * const array = [7, 5, 21];
 *
 * removeAt(array, 1);
 */
export var removeAt = function (array) {
    var indexes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        indexes[_i - 1] = arguments[_i];
    }
    if (typeOf(array) !== 'array' || isNilOrEmpty.any(array, indexes))
        return array;
    if (indexes.length > 1) {
        var output = [];
        indexes = indexes.map(function (x) { return x >= 0 ? x : array.length + x; });
        for (var index_1 = 0; index_1 < array.length; index_1++) {
            if (indexes.indexOf(index_1) === -1) {
                output = __spreadArray(__spreadArray([], output, true), [array[index_1]], false);
            }
        }
        return output;
    }
    var index = first(indexes);
    if (isNaN(index) || array.length <= index || array.length + index < 0)
        return array;
    if (index < 0) {
        index = array.length + index;
        return array.slice(0, index).concat(array.slice(index + 1));
    }
    return array.slice(0, index).concat(array.slice(index + 1));
};
